import moment from "moment";
const momentTz = require("moment-timezone");

import Login from "@/services/login";
import Home from "@/services/Home";
import plantDetail from "@/services/plantDetails";
import User from "@/services/user";
import Utils from '@/util/index.js';

const lib = {};

lib.fetchLoginOtpAction = ({ commit }, payload) => {
  return new Promise(async (resolve, reject) => {
    const data = Utils.encryptPayloadHandler(payload);

    Login.validateUser(data)
      .then((res) => {
        commit("SET_SHOW_SNACKBAR", true);
        if (res.status === 206) {
          commit("SET_SNACKBAR_CONTENT", {
            icon: "error",
            timeout: 5000,
            header: "",
            message: res.data.message,
          });
          const customError = new Error(res.data.message);
          return reject(customError);
        }

        if (res.status === 200) {
          const {
            refreshTime,
            role,
            lastViewedNotificationTime,
            name,
            user_id,
            email,
            logo,
            banner_messages,
            ui_config,
            added_on,
            updated_on
          } = res.data.data;
          const computedRefreshTime =
            refreshTime == null || refreshTime === 0
              ? 300000
              : refreshTime * 60000;

          commit("SET_USER_DATA", {
            refreshTime: computedRefreshTime,
            lastNotificationViewed: lastViewedNotificationTime,
            userId: user_id,
            email,
            userName: name,
            role,
            logo,
            banner_messages,
            addedOn: added_on,
            updatedOn: updated_on,
          });

          if (ui_config && ui_config.home_table && ui_config.home_table.column) {
            const defaultCols = [
              { value: "plant_name", visible: true, textKey: "Plant name" },
              { value: "location", visible: true, textKey: "City/ State/ Country" },
              { value: "generation", visible: true, textKey: "Energy (kWh)" },
              { value: "power", visible: true, textKey: "AC Power (kW)" },
              { value: "acyield", visible: true, textKey: "AC Yield (kWh)" },
              { value: "cuf", visible: true, textKey: "CUF" },
              { value: "ratio", visible: true, textKey: "PR (%)" },
              { value: "albedoCorrPr", visible: true, textKey: "Albedo Corr PR (%)" },
              { value: "tempCorrPr", visible: true, textKey: "Temp Corr PR (%)" },
              { value: "ac_capacity", visible: true, textKey: "AC Capacity (kW)" },
              { value: "alert", visible: true, textKey: "Status" },
            ];

            const savedColValues = new Set(ui_config.home_table.column.map(c => c.value));
            const missingCols = defaultCols.filter(c => !savedColValues.has(c.value));
            const alertIdx = ui_config.home_table.column.findIndex(c => c.value === "alert");
            const mergedCols = [...ui_config.home_table.column];

            if (alertIdx !== -1) {
              mergedCols.splice(alertIdx, 0, ...missingCols);
            } else {
              mergedCols.push(...missingCols);
            }
            commit(
              "SET_PLANT_DATATABLE_COLS",
              mergedCols
            );
          }

          if (ui_config && ui_config.home_table && ui_config.home_table.page_size) {
            commit(
              "SET_PLANT_DATATABLE_SIZE",
              ui_config.home_table.page_size
            );
          }

          if (ui_config && ui_config.home_table && ui_config.home_table.sort_by) {
            commit(
              "SET_PLANT_DATATABLE_SORT_BY",
              ui_config.home_table.sort_by
            );
          }

          if (ui_config && ui_config.home_table && ui_config.home_table.descending !== undefined) {
            commit(
              "SET_PLANT_DATATABLE_DESCENDING",
              ui_config.home_table.descending
            );
          }

          commit("SET_RELOAD_TIMER", computedRefreshTime);
        }

        commit("SET_ACTIVE_LOGIN_SCREEN", "loginOtp");
        commit("SET_SNACKBAR_CONTENT", {
          icon: "success",
          timeout: 5000,
          header: "",
          message: "Please check your email for OTP",
        });

        commit("SET_JWT_TOKEN", res.data.data.login_token);
        const expirationDate = moment(res.data.data.updated_on, "YYYY-MM-DD HH:mm:ss");

        const currentDate = moment();
        const diff = currentDate.diff(expirationDate, "days");
        commit("SET_PASSWORD_RESET_DIFF", diff);

        return resolve(res);
      })
      .catch((err) => {
        const status = err.response.status;
        let errorMessage = "An unknown error occurred.";

        if (status === 423) {
          errorMessage = `Wrong password. This user is locked until ${moment.unix(err.response.data.lockUntil).format("DD-MM-YYYY HH:mm:ss")}`;
        } else if (status === 429) {
          errorMessage = `This user is locked until ${moment.unix(err.response.data.lockUntil).format("DD-MM-YYYY HH:mm:ss")}`;
        } else if (err.response && err.response.data && err.response.data.message) {
          errorMessage = err.response.data.message;
        }

        commit("SET_SHOW_SNACKBAR", true);
        commit("SET_SNACKBAR_CONTENT", {
          icon: "error",
          timeout: 5000,
          header: "",
          message: errorMessage,
        });

        return reject(err);
      });
  });
};

lib.sendResetOtpAction = ({ commit }, email) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await Login.sendResetEmail({
        id: email,
      });

      commit("SET_MAIL_RESEND_TIME", 2 * 60);
      if (response.data.attemptTimeRemaining == 0) {
        commit("SET_SHOW_SNACKBAR", true);
        commit("SET_SNACKBAR_CONTENT", {
          icon: "success",
          timeout: 5000,
          header: "",
          message: "Please check email for OTP sent",
        });

        commit("SET_ACTIVE_LOGIN_SCREEN", "resetOtp");
      } else {
        commit("SET_SHOW_SNACKBAR", true);
        commit("SET_SNACKBAR_CONTENT", {
          icon: "error",
          timeout: 5000,
          header: "",
          message: `You just updated the password, you can update after ${moment()
            .add(response.data.attemptTimeRemaining, "minutes")
            .format("dd-mm-yyyy h:mm")}`,
        });
      }

      return resolve(response);
    } catch (err) {
      commit("SET_SHOW_SNACKBAR", true);
      commit("SET_SNACKBAR_CONTENT", {
        icon: "error",
        timeout: 5000,
        header: "",
        message: err.message,
      });
      return reject(err);
    }
  });
};

lib.loginWithOtpAction = ({ commit, dispatch, getters }, payload) => {
  return new Promise(async (resolve, reject) => {
    const { userId, code, info } = payload;
    const data = Utils.encryptPayloadHandler({
      userId,
      code,
      info,
    });

    Login.login(data)
      .then(async (response) => {
        if (response.status === 200) {
          const plantDetails = response.data.data;

          const timeZone = plantDetails[0].timezone;
          if (plantDetails.length > 1) {
            commit("SET_SHOW_HOME_DB", true);
          } else {
            // Logic for Users who has only 1 plant
            const renewDate = plantDetails[0].renew_date;

            if (renewDate && momentTz().tz(timeZone).isAfter(moment(renewDate))) {
              commit("SET_SHOW_HOME_DB", true);
            } else {
              commit("SET_SHOW_HOME_DB", false);
            }
          }

          let expiredPlantCount = 0;
          let renewPlantCount = 0;
          let aboutToExpireCount = 0;
          const mappedPlantData = plantDetails.reduce((holder, data) => {
            const {
              plant_id: plantId,
              expiry_date: expiryDate,
              renew_date: renewDate,
            } = data;
            if (renewDate && momentTz().tz(timeZone).isAfter(moment(renewDate))) {
              if (expiryDate && momentTz().tz(timeZone).isAfter(moment(expiryDate))) {
                expiredPlantCount++;
              } else {
                renewPlantCount++;
              }
            } else if (
              expiryDate &&
              moment(expiryDate).diff(momentTz().tz(timeZone), "days") >= 0 &&
              moment(expiryDate).diff(momentTz().tz(timeZone), "days") <= 30
            ) {
              aboutToExpireCount++;
            }

            holder[plantId] = data;
            return holder;
          }, {});

          commit("SET_EXPIRED_PLANT_COUNT", expiredPlantCount);
          commit("SET_RENEW_PLANT_COUNT", renewPlantCount);
          commit("SET_PLANT_NEAR_EXPIRY_COUNT", aboutToExpireCount);
          commit("SET_PLANT_DATA", mappedPlantData);

          commit("SET_JWT_TOKEN", response.data.token);
          const diff = getters.getGeneralState("passwordResetDiff");
          if (diff < 85) {
            await dispatch("fetchActivePlantDetails", plantDetails[0].plant_id);

            if (getters.getGeneralState("theme") == "light") {
              commit("SET_THEME", false);
            } else {
              commit("SET_THEME", true);
            }

            commit("SET_PASSWORD_UPDATE_SKIP", true);
            commit("SET_SHOW_SNACKBAR", true);
            commit("SET_SNACKBAR_CONTENT", {
              icon: "success",
              timeout: 5000,
              header: "",
              message: "Login successful!",
            });
          } else {
            const message =
              diff >= 90
                ? "Your Password has expired! Please change your password!"
                : `${90 - diff} days before password validity expires!`;
            commit("SET_PASSWORD_UPDATE_SKIP", false);
            commit("SET_SHOW_SNACKBAR", true);
            commit("SET_SNACKBAR_CONTENT", {
              icon: "warning",
              timeout: 5000,
              header: "",
              message: message,
            });
            commit("SET_PASSWORD_CHANGE_STATUS", "update");
          }

          return resolve(response);
        }
      })
      .catch((err) => {
        return reject(err);
      });
  });
};

lib.verifyResetOtpAction = ({ commit }, payload) => {
  return new Promise(async (resolve, reject) => {
    Login.verifyOtpHandler(payload)
      .then((res) => {
        commit("SET_PASSWORD_CHANGE_STATUS", "reset");
        const userData = {
          email: payload.email
        };
        commit("SET_USER_DATA", userData);
        return resolve(res);
      })
      .catch((err) => {
        commit("SET_SHOW_SNACKBAR", true);
        commit("SET_SNACKBAR_CONTENT", {
          icon: "error",
          timeout: 5000,
          header: "",
          message: "OTP verification failed",
        });
        return reject(err);
      });
  });
};

lib.validateUserAction = ({ commit }, payload) => {
  return new Promise(async (resolve, reject) => {
    const data = Utils.encryptPayloadHandler(payload);

    Login.userValidation(data)
      .then((res) => {
        if (res.status === 400) {
          let payload = {
            icon: "error",
            header: "",
            message: this.$t("Username or password entered is incorrect"),
          };
          commit("SET_SNACKBAR_CONTENT", payload);
          commit("SET_SHOW_SNACKBAR", true);
          commit("SET_SNACKBAR_CONTENT", payload);
          commit("SET_SHOW_SNACKBAR", true);

          const customError = new Error('Username or password entered is incorrect');
          return reject(customError);
        }

        return resolve(res);
      })
      .catch((err) => {
        console.log("ERR", err);
        return reject(err);
      });
  });
};

lib.updatePasswordAction = ({ commit, dispatch, getters }, payload) => {
  return new Promise(async (resolve, reject) => {
    const data = Utils.encryptPayloadHandler(payload);
    commit("SET_PROGRESS_BAR", true);

    Login.updatePassword(data)
      .then(async (res) => {
        commit("SET_PASSWORD_UPDATE_SKIP", true);

        if (getters.getGeneralState("passwordChangeStatus") == "update") {
          await dispatch("fetchActivePlantDetails", getters.getPlantList[0].id);

          if (getters.getGeneralState("theme") == "light") {
            commit("SET_THEME", false);
          } else {
            commit("SET_THEME", true);
          }

          commit("SET_SHOW_SNACKBAR", true);
          commit("SET_SNACKBAR_CONTENT", {
            icon: "success",
            header: "Success",
            message: "Password updated and successfully logged in!",
          });
        } else {
          // this.$session.destroy();
          dispatch("resetState");
        }

        return resolve(res)
      })
      .catch((err) => {
        commit("SET_PROGRESS_BAR", false);
        commit("SET_SHOW_SNACKBAR", true);
        if (err.response && err.response.status === 400) {
          const errorMessage = (err.response && err.response.data && err.response.data.error);
          commit("SET_SNACKBAR_CONTENT", {
            icon: "error",
            header: "Error",
            message: errorMessage,
            timeout: 5000,
          });
        } else {
          commit("SET_SNACKBAR_CONTENT", {
            icon: "error",
            header: "Error",
            message: "Password Update Failed",
          });
        }

        return reject(err)
      })
  });
};

lib.fetchActivePlantDetails = ({ commit, getters }, plantId) => {
  return new Promise(async (resolve, reject) => {
    plantDetail
      .activePlantDetail(plantId)
      .then((res) => {
        const plantData = getters.getGeneralState("plantData")[plantId];
        const activePlantData = res.data;
        commit("SET_ACTIVE_PLANT", {
          ...activePlantData,
          ...plantData,
        });
        return resolve(res);
      })
      .catch((err) => {
        console.log("ERR", err);
        return reject(err);
      });
  });
};

lib.fetchGenerationData = async ({ commit, getters }, payload) => {
  return new Promise(async (resolve, reject) => {
    // Support both old format (array) and new format (object with plantList + visibleColumns)
    const plantList = Array.isArray(payload) ? payload : payload.plantList;
    const visibleColumns = Array.isArray(payload) ? undefined : payload.visibleColumns;
    const param = {
      plantList,
      ...(visibleColumns && { visibleColumns }),
    };
    var response = await Home.dashboardData(param);
    if (response.status == 200) {
      let data = [];

      Object.values(response.data.message).forEach((element) => {
        const plantDetails = Object.assign({}, element);
        const plantData = getters.getGeneralState("plantData")[element.plant_id];

        if (plantDetails.alert && plantDetails.alert.secondary_alert) {
          delete plantDetails.alert.secondary_alert;
        }

        if (plantDetails.alert && plantDetails.alert.scb) {
          plantDetails.alert["smb"] = plantDetails.alert.scb;
          delete plantDetails.alert.scb;
        }

        plantDetails["plant_name"] = plantData.plant_name;
        plantDetails["location"] = plantData.state || "N/A";
        plantDetails["generation"] =
          element.generation === null || element.generation === undefined
            ? "No data"
            : Math.round(element.generation);
        plantDetails["ac_capacity"] = plantData.ac_capacity || 0;
        plantDetails["power"] =
          element.power === null || element.power === undefined
            ? "No data"
            : element.power;
        plantDetails["country"] = plantData.country || "N/A";
        plantDetails["city"] = plantData.city || "N/A";
        data.push(plantDetails);
      });

      response.data.message = data;
      resolve(response);
    } else {
      reject(err);
    }
  });
};

lib.saveTableConfig = async ({ commit }, payload) => {
  User.updateUserDetails(payload)
    .then((res) => {
      commit(
        "SET_PLANT_DATATABLE_COLS",
        payload.details.ui_config.home_table.column
      );
      commit(
        "SET_PLANT_DATATABLE_SIZE",
        payload.details.ui_config.home_table.page_size
      );
      if (payload.details.ui_config.home_table.sort_by) {
        commit(
          "SET_PLANT_DATATABLE_SORT_BY",
          payload.details.ui_config.home_table.sort_by
        );
      }
      if (payload.details.ui_config.home_table.descending !== undefined) {
        commit(
          "SET_PLANT_DATATABLE_DESCENDING",
          payload.details.ui_config.home_table.descending
        );
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

lib.setLatestNotificationViewTimestamp = ({ commit }, payload) => {
  User.updateUserDetails(payload)
    .then((res) => {
      commit(
        "SET_LATEST_NOTIFICATION_VIEW_TIMESTAMP",
        payload.details.last_viewed_notification_time
      );
    })
    .catch((err) => {
      console.log(err);
    });
};

lib.resetState = ({ commit }) => {
  function reset(arr) {
    for (const element of arr) {
      if (element) {
        commit(`${element}/RESET_STATE`, null, {
          root: true,
        });
      } else {
        commit("RESET_STATE");
      }
    }
  }

  const components = ["settings", "alert", "admin", null];
  reset(components);
};

lib.logoutAction = async ({ commit, dispatch, getters }) => {
  return new Promise(async (resolve, reject) => {
    try {
      const payload = {
        token: getters.getGeneralState("token"),
        userId: getters.getGeneralState("userData").userId,
        email: getters.getGeneralState("userData").email,
      };
      await Login.logoutUser(payload);
    } catch (err) {
      console.error("Logout error:", err);
    } finally {
      localStorage.clear();
      dispatch("resetState");
      return resolve();
    }
  })
}


export default lib;
